module.exports = "/assets/sign-3e174ac9b29e9696b1d498c5c2d179a4.svg";